import { render, staticRenderFns } from "./ProblemsListEditor.vue?vue&type=template&id=2e3f7d8a&"
import script from "./ProblemsListEditor.vue?vue&type=script&lang=js&"
export * from "./ProblemsListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports